<div class="container-fluid fast-quote">

  <div [hidden]="sent">

    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <a backButton>
          <i class="icon-edponline-Bra-073 rotate-90 font-size-24 color-black"></i>
        </a>
      </div>
      <div class="col-12 d-flex justify-content-center fast-quote-title mt-4">
        <span class="pb-3">{{'edp.emarket.fast.quote' | translate}}</span>
      </div>
    </div>

    <div class="row line"></div>

    <div class="row d-flex justify-content-end mx-2 mt-4">
      <span class="add-button" (click)="addRow()" id="btn-add">{{'edp.emarket.fast.quote.adicionar' | translate}}</span>
    </div>

    <form [formGroup]="fastQuoteForm" (ngSubmit)="onSubmit()" class="row px-2 mt-3">

      <div class="form-group col-6 col-md-4 offset-md-2">
        <label for="maturity" class="mat-val-label">
          {{'edp.emarket.fast.quote.maturidade' | translate}}
        </label>
        <mat-form-field floatLabel="never">
          <mat-label class="select-text">{{'edp.emarket.fast.quote.opcao' | translate}}</mat-label>
          <mat-select formControlName="maturity" panelClass="edit-alert-variation">
            <mat-option disabled>
              <div class="d-flex justify-content-between align-items-center">
                <span class="font-size-16 pt-2">{{'edp.emarket.fast.quote.opcao' | translate}}</span>
                <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
              </div>
            </mat-option>
            @for (val of maturityValues; track val) {
              <mat-option value="{{val}}">{{val}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group col-6 col-md-4">
        <label for="value" class="mat-val-label">
          {{'edp.emarket.fast.quote.valor' | translate}}
        </label>
        <mat-form-field floatLabel="never">
          <mat-label class="select-text">%</mat-label>
          <mat-select formControlName="value" panelClass="edit-alert-variation">
            <mat-option disabled>
              <div class="d-flex justify-content-between align-items-center">
                <span class="pt-2 font-size-16"> %</span>
                <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
              </div>
            </mat-option>
            @for (val of percentageValues; track val) {
              <mat-option value="{{val}}">{{val}}%</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (row2) {
        <div class="row w-100 mx-1">
          <div class="col-12 d-flex justify-content-end mb-4">
            <span class="add-button" (click)="removeRow2()" id="btn-remove-2">{{'edp.emarket.fast.quote.remover' | translate}}</span>
          </div>
          <div class="form-group col-6 col-md-4 offset-md-2">
            <label for="maturity2" class="mat-val-label">
              {{'edp.emarket.fast.quote.maturidade' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">{{'edp.emarket.fast.quote.opcao' | translate}}</mat-label>
              <mat-select formControlName="maturity2" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-size-16 pt-2">{{'edp.emarket.fast.quote.opcao' | translate}}</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of maturityValues; track val) {
                  <mat-option value="{{val}}">{{val}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group col-6 col-md-4">
            <label for="value2" class="mat-val-label">
              {{'edp.emarket.fast.quote.valor' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">%</mat-label>
              <mat-select formControlName="value2" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="pt-2 font-size-16"> %</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of percentageValues; track val) {
                  <mat-option value="{{val}}">{{val}}%</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      @if (row3) {
        <div class="row w-100 mx-1">
          <div class="col-12 d-flex justify-content-end mb-4">
            <span class="add-button" (click)="removeRow3()" id="btn-remove-3">{{'edp.emarket.fast.quote.remover' | translate}}</span>
          </div>
          <div class="form-group col-6 col-md-4 offset-md-2">
            <label for="maturity3" class="mat-val-label">
              {{'edp.emarket.fast.quote.maturidade' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">{{'edp.emarket.fast.quote.opcao' | translate}}</mat-label>
              <mat-select formControlName="maturity3" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-size-16 pt-2">{{'edp.emarket.fast.quote.opcao' | translate}}</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of maturityValues; track val) {
                  <mat-option value="{{val}}">{{val}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group col-6 col-md-4">
            <label for="value3" class="mat-val-label">
              {{'edp.emarket.fast.quote.valor' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">%</mat-label>
              <mat-select formControlName="value3" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="pt-2 font-size-16"> %</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of percentageValues; track val) {
                  <mat-option value="{{val}}">{{val}}%</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      @if (row4) {
        <div class="row w-100 mx-1">
          <div class="col-12 d-flex justify-content-end mb-4">
            <span class="add-button" (click)="removeRow4()" id="btn-remove-4">{{'edp.emarket.fast.quote.remover' | translate}}</span>
          </div>
          <div class="form-group col-6 col-md-4 offset-md-2">
            <label for="maturity4" class="mat-val-label">
              {{'edp.emarket.fast.quote.maturidade' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">{{'edp.emarket.fast.quote.opcao' | translate}}</mat-label>
              <mat-select formControlName="maturity4" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-size-16 pt-2">{{'edp.emarket.fast.quote.opcao' | translate}}</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of maturityValues; track val) {
                  <mat-option value="{{val}}">{{val}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group col-6 col-md-4">
            <label for="value4" class="mat-val-label">
              {{'edp.emarket.fast.quote.valor' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">%</mat-label>
              <mat-select formControlName="value4" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="pt-2 font-size-16"> %</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of percentageValues; track val) {
                  <mat-option value="{{val}}">{{val}}%</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      @if (row5) {
        <div class="row w-100 mx-1">
          <div class="col-12 d-flex justify-content-end mb-4">
            <span class="add-button" (click)="removeRow5()" id="btn-remove-5">{{'edp.emarket.fast.quote.remover' | translate}}</span>
          </div>
          <div class="form-group col-6 col-md-4 offset-md-2">
            <label for="maturity5" class="mat-val-label">
              {{'edp.emarket.fast.quote.maturidade' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">{{'edp.emarket.fast.quote.opcao' | translate}}</mat-label>
              <mat-select formControlName="maturity5" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-size-16 pt-2">{{'edp.emarket.fast.quote.opcao' | translate}}</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of maturityValues; track val) {
                  <mat-option value="{{val}}">{{val}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group col-6 col-md-4">
            <label for="value5" class="mat-val-label">
              {{'edp.emarket.fast.quote.valor' | translate}}
            </label>
            <mat-form-field floatLabel="never">
              <mat-label class="select-text">%</mat-label>
              <mat-select formControlName="value5" panelClass="edit-alert-variation">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="pt-2 font-size-16">%</span>
                    <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of percentageValues; track val) {
                  <mat-option value="{{val}}">{{val}}%</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      <div class="row w-100">
        <div class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-4">
          <button class="btn bg w-100 my-3 mx-3" type="submit" id="btn-submit">
            <span class="bg-text">{{'edp.emarket.detalhe.avancar' | translate}}</span>
          </button>
        </div>
      </div>

    </form>

  </div>

  @if (sent) {
    <div>
      <div class="row d-flex justify-content-center">
        <div class="confirm-msg margin-top-74 mb-2">
          <span class="d-block">{{'edp.emarket.fast.quote.confirmar.ordem.f.q.o' | translate}}</span>
          @if (f.value.value && f.maturity.value) {
            <p class="mb-0">
              <span>{{f.value.value}}% de </span>
              <span>{{f.maturity.value}}</span>
              @if (!(!f.value2.value && !f.maturity2.value && !f.value3.value && !f.maturity3.value && !f.value4.value && !f.maturity4.value && !f.value5.value && !f.maturity5.value)) {
                <span> e</span>
              }
              @if (!f.value2.value && !f.maturity2.value && !f.value3.value && !f.maturity3.value && !f.value4.value && !f.maturity4.value && !f.value5.value && !f.maturity5.value) {
                <span>?</span>
              }
            </p>
          }
          @if (f.value2.value && f.maturity2.value) {
            <p class="mb-0">
              <span>{{f.value2.value}}% de </span>
              <span>{{f.maturity2.value}}</span>
              @if (!(f.value.value && f.maturity.value && !f.value3.value && !f.maturity3.value && !f.value4.value && !f.maturity4.value && !f.value5.value && !f.maturity5.value)) {
                <span> e</span>
              }
              @if (f.value.value && f.maturity.value && !f.value3.value && !f.maturity3.value && !f.value4.value && !f.maturity4.value && !f.value5.value && !f.maturity5.value) {
                <span>?</span>
              }
            </p>
          }
          @if (f.value3.value && f.maturity3.value) {
            <p class="mb-0">
              <span>{{f.value3.value}}% de </span>
              <span>{{f.maturity3.value}}</span>
              @if (!(f.value.value && f.maturity.value && f.value2.value && f.maturity2.value && !f.value4.value && !f.maturity4.value && !f.value5.value && !f.maturity5.value)) {
                <span> e</span>
              }
              @if (f.value.value && f.maturity.value && f.value2.value && f.maturity2.value && !f.value4.value && !f.maturity4.value && !f.value5.value && !f.maturity5.value) {
                <span>?</span>
              }
            </p>
          }
          @if (f.value4.value && f.maturity4.value) {
            <p class="mb-0">
              <span>{{f.value4.value}}% de </span>
              <span>{{f.maturity4.value}}</span>
              @if (!(f.value.value && f.maturity.value && f.value2.value && f.maturity2.value && f.value3.value && f.maturity3.value && !f.value5.value && !f.maturity5.value)) {
                <span> e</span>
              }
              @if (f.value.value && f.maturity.value && f.value2.value && f.maturity2.value && f.value3.value && f.maturity3.value && !f.value5.value && !f.maturity5.value) {
                <span>?</span>
              }
            </p>
          }
          @if (f.value5.value && f.maturity5.value) {
            <p class="mb-0">
              <span>{{f.value5.value}}% de </span>
              <span>{{f.maturity5.value}}</span>
              <span>?</span>
            </p>
          }
        </div>
      </div>
      <div class="row px-4 pt-4 margin-top-33">
        <div class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-4">
          <button class="btn bg w-100" (click)="confirm()" [disabled]="pending" id="btn-submit">
            @if (pending) {
              <span class="spinner-border" style="width: 1.25rem; height: 1.25rem;" role="status" aria-hidden="true"></span>
            } @else {
              <span class="bg-text">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
            }
          </button>
        </div>
      </div>
      <div class="row mt-3 px-4">
        <div class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-4">
          <a routerLink="/markets" class="w-100" id="btn-cancel">
            <button class="btn bg-2 w-100">
              <span class="bg-text">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  }
</div>
